
























































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import {Icon} from "@/components/payroll/business/services/RightSideBar.vue";
import RefContactSliderSelector from "@/components/payroll/business/services/contact/RefContactSliderSelector.vue";
import {
	ServiceDTO, ServiceRecordDTO
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceItem from "@/components/payroll/business/services/ServiceItem.vue";
import ServiceSliderSelector from "@/components/payroll/business/services/service/ServiceSliderSelector.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import SelectOption from "@/components/common/SelectOption";
import PortalDate from "@/components/common/PortalDate.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import LocationSliderSelector from "@/components/payroll/business/services/locations/LocationSliderSelector.vue";

@Component({
	computed: {
		SelectOption() {
			return SelectOption
		}
	},
	components: {
		LocationSliderSelector,
		PortalTextarea,
		PortalSelect,
		PortalAddress,
		PortalInput,
		ServiceView,
		PortalDate,
		PortalRadio, PortalCheckbox, ServiceSliderSelector, ServiceItem, RefContactSliderSelector, RightSideBar}
})
export default class ServiceLogUpdateSlider extends Vue {
	@VModel({type: Boolean, default: false})
	private model!: boolean;

	@Prop({default: "xmark"})
	private closeIcon!: Icon

	@Prop()
	private getLog!: () => ServiceRecordDTO | null


	get log(): ServiceRecordDTO {
		return this.getLog()!
	}


	get service(): ServiceDTO {
		return {
			id: this.log.serviceId,
			name: this.log.title,
			description: this.log.description,
			price: this.log.unitAmount,
			salable: this.log.salable,
			schedule: this.log.schedule,
			holder: this.log.executor,
			active: true,
			coefficient: null,
			formattedPrice: this.log.formattedPrice
		}
	}

	get serviceFromLog(): ServiceDTO {
		return {
			id: this.log.serviceId,
			name: this.log.title,
			description: this.log.description,
			price: this.log.unitAmount,
			active: true,
			formattedPrice: this.log.formattedPrice,
			salesRate: this.log.salesRate,
			holder: this.log.executor,
			salable: this.log.salable,
			schedule: this.log.schedule,
			coefficient: null
		}
	}
}
